import { getWorkSheetsByTerminalName } from "./getWorkSheet";
import Excel from 'exceljs'
import { saveAs } from 'file-saver'

const headers = [
    {
        header: 'Mês',
        key: 'id',
        width: 8
    },
    {
        header: 'Nº',
        key: 'n',
        width: 5
    },
    {
        header: 'Data do incidente',
        key: 'data',
        width: 20
    },
    {
        header: 'Classe',
        key: 'classe',
        width: 12
    },
    {
        header: 'Stop card',
        key: 'stop_card',
        width: 12
    },
    {
        header: 'Quem reportou',
        key: 'reportado_por',
        width: 20
    },
    {
        header: 'O que aconteceu',
        key: 'descricao',
        width: 70
    },
    {
        header: 'Acção imediata',
        key: 'medidas_imediatas',
        width: 70
    },
    {
        header: 'Status',
        key: 'estado',
        width: 10
    },
    {
        header: 'Piloto',
        key: 'responsavel',
        width: 20
    }
]

export function classADataExporter() {

    async function exportData(rows, titulo) {
        const workbook = new Excel.Workbook();
        const workSheets = getWorkSheetsByTerminalName(rows)
        let sheet = {};
        let startIndex = 3
        let inserted = [];

        Object?.keys?.(workSheets)?.map((workSheet) => {
            let columns = []
            sheet = workbook.addWorksheet(workSheet)

            headers.forEach(header => {
                columns.push({
                    header: titulo,
                    key: header.key,
                    width: header.width,
                    subHeader: header.header,
                });
            });

            sheet.columns = columns;
            sheet.mergeCells(1, 1, 1, headers.length);

            let row1 = sheet.getRow(1);
            let secondRow = sheet.getRow(2);
            secondRow.values = columns.map((col) => col.subHeader);
            secondRow.height = 30;
            row1.height = 30;

            secondRow.eachCell((cell, _) => {
                cell.font = { bold: true, color: { argb: 'FFFFFF' } };
                cell.alignment = { vertical: 'middle' };
                cell.fill = { fgColor: { argb: '858585' }, type: 'pattern', pattern: 'solid', };
            });

            for (let i = 1; i <= 8; i++) {
                sheet.getColumn(i).eachCell((cell) => {
                    cell.alignment = { wrapText: true };
                });
            }

            headers.forEach((_, index) => {
                const cell = sheet.getCell(1, index + 1);
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '28528D' }
                };
                cell.font = {
                    bold: true,
                    color: { argb: 'FFFFFFFF' }
                };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            });

            let startMerge = 3;

            Object?.keys?.(workSheets[workSheet]).forEach((sectionKey) => {
                const sectionRows = workSheets?.[workSheet]?.[sectionKey];

                sectionRows.forEach((rowData) => {
                    const row = sheet.addRow(rowData);

                    row.eachCell((cell) => {
                        cell.alignment = {
                            ...cell.alignment,
                            wrapText: true
                        };
                    });
                });

                const endMerge = startMerge + sectionRows.length - 1;
                sheet.mergeCells(startMerge, 1, endMerge, 1);

                const mergedCell = sheet.getCell(startMerge, 1);
                mergedCell.font = { bold: true };
                mergedCell.value = sectionKey;
                mergedCell.alignment = {
                    vertical: 'middle',
                    horizontal: 'center',
                    wrapText: true,
                    textRotation: 90
                }

                startMerge = endMerge + 1;
            });


        })

        const buf = await workbook.xlsx.writeBuffer()
        saveAs(new Blob([buf]), titulo + ".xlsx")
    }

    return { exportData }
}